export class DashboardFilter {
  public cropYear: string;
  public companyCode: string;
  public shipToAccount: number;
  public gMk: number;
}
